import React, { FC } from 'react';
import styled  from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Link } from '@reach/router';
import { globalTheme } from '@cld/component-theme';
import { website } from '@cld/typography';
import { overrides } from '@cld/button';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { toDemo } from '../../../../router';

const StyledButton = styled(overrides.mediaLibraryWidgetDemoOverrides.Button)`
  margin-top: ${globalTheme.spacing.xxs};
`;

const Root = styled.div`
  width: calc(${globalTheme.spacing.lg} * 23);
  margin-left: calc(${globalTheme.spacing.lg} * 10);
`;

const Heading = styled.h1`
  ${website.headlines.xxxxl.contrastInvert};
  margin: 0;
`;

const Contents = styled.p`
  ${website.brandText.lg.contrastInvert};
`;

export const Intro: FC = () => {
  const analytics = useAnalytics();

  return (
    <Root>
      <Heading>
        <FormattedMessage {...messages['landing.h1']} />
      </Heading>
      <Contents>
        <FormattedMessage {...messages['landing.header.intro']} />
      </Contents>
      <Link to={toDemo()} data-test="header-try-it-now-button">
        <StyledButton size="lg" shape="pill" variant="secondary" onClick={() => analytics('navigate', 'try it now')}>
          <FormattedMessage {...messages['landing.header.tryItNow']} />
        </StyledButton>
      </Link>
    </Root>
  );
};
